"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandler = void 0;
var ErrorHandler = (function () {
    function ErrorHandler(test, handler) {
        this.test = test;
        this.handler = handler;
    }
    return ErrorHandler;
}());
exports.ErrorHandler = ErrorHandler;
//# sourceMappingURL=types.js.map